import buttonsMutations from "./mutations.js";
import buttonsActions from "./actions.js";
import buttonsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      buttons : {}
    };
  },
  mutations: buttonsMutations,
  actions: buttonsActions,
  getters: buttonsGetters,
};
